export default __webpack_public_path__ + "static/media/dai.735b82a2.png";